// §6.5 the one chip spec — forever. 5px 9px padding, 999 radius,
// Hanken 600 10.5px. Two surface variants: dark (default, lives on
// --abyss) and light (`.on-light`, lives on --paper / --sand). Every
// chip in the old code with different padding/font/casing converges
// here; this is the emblem of the Lagoon cleanup (§6.5 spec text).

import type { ReactNode } from "react";

export interface ChipProps {
  children: ReactNode;
  /** Light context when true (on --paper / --sand). */
  onLight?: boolean;
  className?: string;
}

export function Chip({ children, onLight = false, className = "" }: ChipProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-[9px] py-[5px] text-[10.5px] font-semibold leading-none
        ${
          onLight
            ? "bg-ink/[0.06] text-meta"
            : "bg-paper-ink/[0.08] text-paper-ink/[0.72]"
        } ${className}`}
    >
      {children}
    </span>
  );
}
